import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { hasTranslationsLoaded, translationChanged } from 'app/infrastructure/translate/selectors';
import { getExperienceTransferAdminAccess } from '../../get-access';
import { ListWrapperProps } from 'app/area/experience-transfer/operations/types-store';

export class ListWrapper
  extends React.PureComponent<ListWrapperProps> {

  public componentDidMount() {
    if (hasTranslationsLoaded(this.props.translation)) {
      this.initList();
    }
  }

  public componentDidUpdate(prevProps: ListWrapperProps) {
    if (translationChanged(this.props.translation, prevProps.translation)) {
      this.initList();
    }
  }

  private initList() {

    const { sharedState, displayError, translation } = this.props;

    if (!getExperienceTransferAdminAccess(sharedState)) {
      displayError(translation.no_access_to_experience_transfer);
      navigate.toStartupView(true);
    }
  }

  public render() {

    if (!getExperienceTransferAdminAccess(this.props.sharedState)) {
      return null;
    }

    return this.props.children;
  }
}
